import { IImage, ISiteImage } from "../../types";
import { ImageActionsTypes } from "../actions/imageActions";

export const SET_IS_IMAGES_LOADING_IN_PROGRESS =
  "image/SET_IS_IMAGES_LOADING_IN_PROGRESS";
export const SET_IMAGES = "image/SET_IMAGES";
export const SET_TOTAL_IMAGES = "image/SET_TOTAL_IMAGES";
export const SET_SITE_IMAGES = "image/SET_SITE_IMAGES";
export const SET_IS_IMAGES_DELETING_IN_PROGRESS =
  "image/SET_IS_IMAGES_DELETING_IN_PROGRESS";

const initialState = {
  isImagesLoadingInProgress: false,
  isImageDeletingInProgress: false,
  images: [] as IImage[],
  siteImages: [] as ISiteImage[],
  imagesTotal: 0,
};

type InitialStateType = typeof initialState;

export const imageReducer = (
  state = initialState,
  action: ImageActionsTypes
): InitialStateType => {
  switch (action.type) {
    case SET_IS_IMAGES_LOADING_IN_PROGRESS:
    case SET_IMAGES:
    case SET_TOTAL_IMAGES:
    case SET_IS_IMAGES_DELETING_IN_PROGRESS:
    case SET_SITE_IMAGES:
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
};
